import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AkebonoCoreModule } from '@akebono/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { TranslateModule } from '@ngx-translate/core';
import { DiffOutline } from '@ant-design/icons-angular/icons';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FormsModule } from '@angular/forms';
import { LotAddCarInspectionAdminButtonComponent } from './lot-add-car-inspection-admin-button.component';
import { LotAddCarInspectionAdminFormModalComponent } from './components/lot-add-car-inspection-admin-form-modal/lot-add-car-inspection-admin-form-modal.component';
import { LotAddCarInspectionAdminFormModalAgentComponent } from './components/lot-add-car-inspection-admin-form-modal/components/lot-add-car-inspection-admin-form-modal-agent/lot-add-car-inspection-admin-form-modal-agent.component';

@NgModule({
  declarations: [
    LotAddCarInspectionAdminButtonComponent,
    LotAddCarInspectionAdminFormModalComponent,
    LotAddCarInspectionAdminFormModalAgentComponent,
  ],
  imports: [
    CommonModule,
    AkebonoCoreModule,
    NzButtonModule,
    TranslateModule,
    NzIconModule.forRoot([DiffOutline]),
    NzSpinModule,
    NzFormModule,
    NzInputModule,
    NzModalModule,
    NzSelectModule,
    FormsModule,
  ],
  exports: [LotAddCarInspectionAdminButtonComponent],
})
export class LotAddCarInspectionAdminButtonModule {}
